import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./use-auth";

export interface Modulos {
  creditosPrePagos: boolean;
  laudosGratisPorCliente: number;
  artMultipla: boolean;
  artPorRt: boolean;
  splitPagamento: boolean;
  nfeAtivado: boolean;
  detranVeiculoFoto: boolean;
  /** A vistoriadora tem exatamente 1 Técnico de Vistoria ativo (só o Parceiro recebe true). */
  tvUnico: boolean;
}

const DEFAULT: Modulos = {
  creditosPrePagos: false,
  laudosGratisPorCliente: 0,
  artMultipla: false,
  artPorRt: false,
  splitPagamento: false,
  nfeAtivado: false,
  detranVeiculoFoto: false,
  tvUnico: false,
};

export function useModulos(): { modulos: Modulos; isLoading: boolean } {
  const { session } = useAuth();

  const { data, isLoading } = useQuery<Modulos>({
    queryKey: ["/api/configuracoes", "modulos"],
    queryFn: async () => {
      const res = await fetch("/api/configuracoes", {
        headers: { Authorization: `Bearer ${session?.access_token}` },
      });
      if (!res.ok) return DEFAULT;
      const json = await res.json();
      return {
        creditosPrePagos: json.creditosPrePagos ?? false,
        laudosGratisPorCliente: json.laudosGratisPorCliente ?? 0,
        artMultipla: json.artMultipla ?? false,
        artPorRt: json.artPorRt ?? false,
        splitPagamento: json.splitPagamento ?? false,
        nfeAtivado: json.nfeAtivado ?? false,
        detranVeiculoFoto: json.detranVeiculoFoto ?? false,
        tvUnico: json.tvUnico ?? false,
      };
    },
    enabled: !!session,
    staleTime: 5 * 60 * 1000,
  });

  return { modulos: data ?? DEFAULT, isLoading };
}
